import { TournamentOverviewPage } from "@/pages/tournament/overview/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/tournament/overview")({
    component: TournamentOverviewPage,
});
